import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import ProjectDetail from './pages/ProjectDetail';
import Hiring from './pages/Hiring';
import VerifyCertificate from './pages/VerifyCertificate';
import { AnimatePresence } from 'framer-motion';

function ScrollToTopOnRoute() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    if (!state || !state.scrollTo) {
      window.scrollTo(0, 0);
    }
  }, [pathname, state]);

  return null;
}

function AppContent() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 overflow-x-hidden font-sans antialiased transition-colors duration-200">
      <ScrollToTopOnRoute />
      <Navbar showApply={true} />

      <main>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />
            <Route path="/hiring" element={<Hiring />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/verify" element={<VerifyCertificate />} />
            <Route path="/verify/:credential_id" element={<VerifyCertificate />} />
          </Routes>
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
